import React, {useState} from 'react';
import {Container, Row, Col} from 'reactstrap';

import image6_1 from "../../../assets/images/Project/6.1.png";
import image6_2 from "../../../assets/images/Project/6.2.png";
import image6_3 from "../../../assets/images/Project/6.3.png";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Products = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <section className="section bg-light" id="marketplace">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">
                                    {t('t-face-id-opportunities-head').replace('{appName}', appConfig.appName)}
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        <img className='avatar-sm' src={image6_1} alt=''/>
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">{t('t-face-id-opportunities1')}</h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-face-id-opportunities1-desc').replace('{appName}', appConfig.appName)}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        <img className='avatar-sm' src={image6_2} alt=''/>
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">{t('t-face-id-opportunities2')}</h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-face-id-opportunities2-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        <img className='avatar-sm' src={image6_3} alt=''/>
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">{t('t-face-id-opportunities3')}</h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-face-id-opportunities3-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Products;